import React from 'react';
import styles from './SwapCalculator.module.scss';

interface TokenSwapButtonProps {
  onClick: () => void;
}

const TokenSwapButton: React.FC<TokenSwapButtonProps> = ({ onClick }) => (
  <button
    type="button"
    className={styles.swapCalcSwapIconBtn}
    aria-label="Swap tokens"
    onClick={onClick}
    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
  >
    <img src="/tkn_lnd_pg_assets/images/icons/icon_swap.svg" alt="swap" width={32} height={32} className={styles.swapCalcSwapIcon} />
  </button>
);

export default TokenSwapButton; 